// es-ES sin agrupar miles en números de 4 cifras; aquí siempre punto de miles y 2 decimales.
export const formatNumber = (value: number | string) => {
  const n = Number(value)
  const [int, dec] = Math.abs(n).toFixed(2).split('.')
  return `${n < 0 ? '-' : ''}${int.replace(/\B(?=(\d{3})+(?!\d))/g, '.')},${dec}`
}
